/**
 * Enum for sorting keys in the SPR Sim list.
 *
 * @enum {string}
 * @readonly
 */
export const enum SprSimListSortKey {
  SIM_NAME = 'simname',
  CLIENT_NAME = 'clientname',
  ZIP_CODE = 'zipcode',
  SIM_NUMBER = 'simnumber',
  MSISDN = 'msisdn',
  ACTIVATION_DATE = 'activationdate',
  PLAN_ID = 'planid',
  DATE_PLAN_CHANGED = 'datePlanChanged',
}

/**
 * Enum for different tabs values in the SPR Sim list.
 *
 * @enum {string}
 * @readonly
 */
export const enum SprSimListTabName {
  ACTIVE = 'active',
  ACTIVATION_IN_PROGRESS = 'activationInProgress',
  AVAILABLE_PSIM = 'inactive',
  PAUSED = 'paused',
  DEACTIVE = 'deactive',
  AVAILABLE_ESIM = 'availableeSim',
}
